import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import MessageIcon from '@mui/icons-material/Message';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import { blue } from '@mui/material/colors';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { IShipmentClientMsgRes, IShipmentClientprintlablesRes, IShipmentClientRes, IUser } from '../../interface/IUser';
import { Button, DialogActions, DialogContent, Stack, Typography } from '@mui/material';


export interface ShipRushDialogProps {
  open: boolean;
  ShipRushResult: IShipmentClientRes;
  onClose: (open: boolean) => void;
  Title: string;

}

export default function ShipRushDialog(props: ShipRushDialogProps) {
  const { open, ShipRushResult, onClose, Title } = props;  
  const handleClose = () => {
    onClose(false);
  };
  // const handlePrint = () => {
    
   
  //   const printWindow = window.open('', '_blank');
  //   printWindow.document.write(`
  //     <html>
  //       <head>
  //       <title>Print Base64 Images</title>
  //       <style>
  //         @media print {
  //           .page-break {
  //             page-break-after: always;
  //           }
  //         }
  //         body {
  //           margin: 0;
  //           padding: 0;
  //         }
  //         .image-container {
  //           display: flex;
  //           justify-content: center;
  //           align-items: center;
  //           height: 100vh;
  //           page-break-inside: avoid;
  //         }
  //         img {
  //           max-width: 90%;
  //           max-height: 90%;
  //         }
  //       </style>
  //     </head>

  //       <body>
  //        ${ShipRushResult.printLables.map(src => `<img src="${src.dataLabel}" />`).join('')}
  //       <script>
  //         window.onload = function() {
  //           window.print();
  //           window.onafterprint = function() {
  //             window.close();
  //           };
  //         };
  //       </script>

  //       </body>
  //     </html>
  //   `);
  //   printWindow.document.close();
  // };



  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>{Title}</DialogTitle>
      <DialogContent>
      <Typography sx={{ marginBottom: 2 , color: ShipRushResult.isSuccess === 'Error' ? 'red' : 'black'}}>
          Status: {ShipRushResult.isSuccess === 'true' ?  'Success': 
                ShipRushResult.isSuccess ===  'false' ? 'Error' : 
                ShipRushResult.isSuccess}
        </Typography>
      <Typography sx={{ marginBottom: 2 , color: ShipRushResult.isSuccess === 'Error' ? 'red' : 'black'}}>
          external id: {ShipRushResult.ShipmentNumber}
        </Typography>
        
        <List sx={{ pt: 0 ,color: ShipRushResult.isSuccess === 'Error' ? 'red' : 'black'}}>
          {ShipRushResult.messages?.map((chiled: IShipmentClientMsgRes) => (
            <ListItem disablePadding >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  <MessageIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText >
                {chiled.Severity }  {chiled.textMessage}
              </ListItemText>
            </ListItem>
          ))}
        </List>
        {
          ShipRushResult.isSuccess === 'Succsess' ?
        <Typography sx={{ marginBottom: 2 , color: 'black' }}>
          Print Labels 
         </Typography>
         :
         <></>
        }
          <Stack direction='row' spacing={2}
              //spacing={{ xs: 1, sm: 2, md: 4 }}
              >
                {ShipRushResult.printLables.map(src => 
          <img width={200} height={300} src={src.dataLabel} alt="Screenshot" />              
          )}
          </Stack>
          
      </DialogContent>
      <DialogActions>
        {/* {
          ShipRushResult.isSuccess === 'true'  ?
        
      <Button  variant='contained' onClick={(e)=> handlePrint()}>
            Print
          </Button>
          :<></>
      } */}
          <Button  variant='contained' onClick={(e)=> onClose(false)}>
            Close
          </Button>
          
        </DialogActions>
    </Dialog>
  );
}
